/**
 * Resting Page — what the portal shows when there is no session.
 *
 * AXF-1013 AC-7: the portal has no sign-in of its own, so there is nothing to redirect to. The old
 * LoginPage at this route fired `gatewayClient.login()` from a `useEffect`; doing that now would
 * bounce into an `/authorize` round-trip the portal is no longer allowed to start.
 *
 * Deliberately: no automatic redirect, no error status, and no network call of any kind.
 * `ENV.APP_URL` empty renders the text without the button rather than a dead one (spec R12) — the
 * sentence is the load-bearing half.
 */
import { Button, Result } from 'antd'
import { SafetyCertificateOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { ENV } from '@shared/config/env'

export function RestingPage() {
  const { t } = useTranslation()

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f5f5',
      }}
    >
      <Result
        icon={<SafetyCertificateOutlined style={{ color: '#00263E' }} />}
        title={t('auth.restingTitle')}
        subTitle={t('auth.restingSubtitle')}
        extra={
          ENV.APP_URL ? (
            <Button type="primary" href={ENV.APP_URL}>
              {t('auth.openAxWorkFlow')}
            </Button>
          ) : null
        }
      />
    </div>
  )
}

export default RestingPage
